export default __webpack_public_path__ + "static/media/2locaweb2-email.b588d966.svg";